import { createAction, props } from '@ngrx/store';
import {
    AddressDTO,
    BankDetailsDTO,
    CentralRegulatorDTO,
    NoteDTO,
    PlatformLicenseActivationDTO
} from '@iota/iota-management-portal-v4-client';
import { CentralRegulatorDTO as InhCoreCentralRegulatorDTO } from '@iota/inh-core-v1-management-client';

export enum CentralRegulatorsActionTypes {
    LoadCentralRegulators = '[Regulators] LoadCentralRegulators',
    LoadCentralRegulatorsSuccess = '[Regulators] LoadCentralRegulatorsSuccess',
    LoadCentralRegulatorsFailure = '[Regulators] LoadCentralRegulatorsFailure',

    ReloadRegulator = '[Regulators] Reload Regulator',
    ReloadRegulatorSuccess = '[Regulators] Reload Regulator Success',
    ReloadRegulatorFailure = '[Regulators] Reload Regulator Failure',

    LoadCustomersCount = '[Regulators] Load Customers Count',
    LoadCustomersCountSuccess = '[Regulators] Load Customers Count Success',
    LoadCustomersCountFailure = '[Regulators] Load Customers Count Failure',

    UpsertRegulator = '[Regulators] Upsert Regulator',
    UpsertRegulatorSuccess = '[Regulators] Upsert Regulator Success',
    UpsertRegulatorFailure = '[Regulators] Upsert Regulator Failure',

    UpsertCentralRegulatorAddress = '[Regulators] Upsert Central Regulator Address',
    UpsertCentralRegulatorAddressSuccess = '[Regulators] Upsert Central Regulator Address Success',
    UpsertCentralRegulatorAddressFailure = '[Regulators] Upsert Central Regulator Address Failure',

    DeleteCentralRegulatorAddress = '[Regulators] Delete Central Regulator Address',

    UpsertRegulatorBankDetails = '[Regulators] Upsert Regulator Bank Details',
    UpsertRegulatorBankDetailsSuccess = '[Regulators] Upsert Regulator Bank Details Success',
    UpsertRegulatorBankDetailsFailure = '[Regulators] Upsert Regulator Bank Details Failure',

    UpsertRegulatorNote = '[Regulators] Upsert Regulator Note',
    RemoveRegulatorNote = '[Regulators] Remove Regulator Note'
}

export const LoadCentralRegulators = createAction(CentralRegulatorsActionTypes.LoadCentralRegulators);
export const LoadCentralRegulatorsSuccess = createAction(
    CentralRegulatorsActionTypes.LoadCentralRegulatorsSuccess,
    props<{ regulators: InhCoreCentralRegulatorDTO[] }>()
);
export const LoadCentralRegulatorsFailure = createAction(
    CentralRegulatorsActionTypes.LoadCentralRegulatorsFailure,
    props<{ error: any }>()
);

export const ReloadRegulator = createAction(CentralRegulatorsActionTypes.ReloadRegulator, props<{ centralRegulatorId: string }>());
export const ReloadRegulatorSuccess = createAction(
    CentralRegulatorsActionTypes.ReloadRegulatorSuccess,
    props<{ regulator: CentralRegulatorDTO }>()
);
export const ReloadRegulatorFailure = createAction(CentralRegulatorsActionTypes.ReloadRegulatorFailure, props<{ error: any }>());

export const LoadCustomersCount = createAction(CentralRegulatorsActionTypes.LoadCustomersCount, props<{ regulatorId: string }>());
export const LoadCustomersCountSuccess = createAction(
    CentralRegulatorsActionTypes.LoadCustomersCountSuccess,
    props<{ regulatorId: string; count: number }>()
);
export const LoadCustomersCountFailure = createAction(
    CentralRegulatorsActionTypes.LoadCustomersCountFailure,
    props<{ regulatorId: string; error: any }>()
);

export const UpsertRegulator = createAction(CentralRegulatorsActionTypes.UpsertRegulator, props<{ regulator: CentralRegulatorDTO }>());
export const UpsertRegulatorSuccess = createAction(
    CentralRegulatorsActionTypes.UpsertRegulatorSuccess,
    props<{ regulator: CentralRegulatorDTO }>()
);
export const UpsertRegulatorFailure = createAction(CentralRegulatorsActionTypes.UpsertRegulatorFailure, props<{ error: any }>());

export const UpsertCentralRegulatorAddress = createAction(
    CentralRegulatorsActionTypes.UpsertCentralRegulatorAddress,
    props<{ centralRegulatorId: string; address: AddressDTO }>()
);
export const UpsertCentralRegulatorAddressFailure = createAction(
    CentralRegulatorsActionTypes.UpsertCentralRegulatorAddressFailure,
    props<{ error: any }>()
);

export const DeleteCentralRegulatorAddress = createAction(
    CentralRegulatorsActionTypes.DeleteCentralRegulatorAddress,
    props<{ centralRegulatorId: string; addressId: string }>()
);

export const UpsertRegulatorBankDetails = createAction(
    CentralRegulatorsActionTypes.UpsertRegulatorBankDetails,
    props<{ centralRegulatorId: string; bankDetails: BankDetailsDTO }>()
);
export const UpsertRegulatorBankDetailsFailure = createAction(
    CentralRegulatorsActionTypes.UpsertRegulatorBankDetailsFailure,
    props<{ error: any }>()
);

export const UpsertRegulatorNote = createAction(CentralRegulatorsActionTypes.UpsertRegulatorNote, props<{ note: NoteDTO }>());
export const RemoveRegulatorNote = createAction(CentralRegulatorsActionTypes.RemoveRegulatorNote, props<{ noteId: string }>());

export const UpsertCentralRegulatorPlatformLicenseActivation = createAction(
    '[Company] UpsertCentralRegulatorPlatformLicenseActivation',
    props<{ plaformLicenseActivation: PlatformLicenseActivationDTO }>()
);
export const UpsertCentralRegulatorPlatformLicenseActivationFailure = createAction(
    '[Company] UpsertCentralRegulatorPlatformLicenseActivationFailure',
    props<{ error: any }>()
);
export const RemovePlatformLicenseActivationFromSelectedCentralRegulator = createAction(
    '[Company] RemovePlatformLicenseActivationFromSelectedCentralRegulator',
    props<{ platformLicenseActivationId: string }>()
);
export const RemovePlatformLicenseActivationFromSelectedCentralRegulatorFailure = createAction(
    '[Company] RemovePlatformLicenseActivationFromSelectedCentralRegulatorFailure',
    props<{ error: any }>()
);

export const LoadPlatformLicenseActivationsOfCentralRegulatorThatHaveNotBeenInvoiced = createAction(
    '[Regulators] LoadPlatformLicenseActivationsOfCentralRegulatorThatHaveNotBeenInvoiced',
    props<{ centralRegulatorId: string }>()
);
export const LoadPlatformLicenseActivationsOfCentralRegulatorThatHaveNotBeenInvoicedSuccess = createAction(
    '[Regulators] LoadPlatformLicenseActivationsOfCentralRegulatorThatHaveNotBeenInvoicedSuccess',
    props<{ licenseActivationIdsThatHaveNotBeenInvoiced: string[] }>()
);
export const LoadPlatformLicenseActivationsOfCentralRegulatorThatHaveNotBeenInvoicedFailure = createAction(
    '[Regulators] LoadPlatformLicenseActivationsOfCentralRegulatorThatHaveNotBeenInvoicedFailure',
    props<{ error: any }>()
);

export const RemoveCentralRegulatorAttachment = createAction(
    '[Regulators] RemoveCentralRegulatorAttachment',
    props<{ centralRegulatorId: string; documentDescriptionId: string }>()
);

export const CentralRegulatorActionFailure = createAction('[Regulators] CentralRegulatorActionFailure', props<{ error: any }>());
